import 'classlist-polyfill';
import 'core-js/es6/array';
import 'core-js/es6/object';

import wrapper from 'wrapper';
import Gallery from './components/gallery/gallery';

class App {
    constructor() {
        this.gallery = new Gallery(wrapper.select('#gallery'), {
            interval: 500,
            buffer: 2000,
        });
        this.gallery
            .withNavButtons()
            .withPlaybackButton()
            .withProgress()
            .withAutoplay();
        this.dates = this.buildDate(1, 2011);
        this.status = wrapper.select('.gallery__container .status');

        this.gallery.addEventListener('indexchange', (index) => this.renderStatus(index));
        this.renderStatus(this.gallery.state.index);

        wrapper.selectAll('.no-js')
            .forEach(e => e.classList.remove('no-js'));
    }

    buildDate(startMonth, startYear) {
        const len = this.gallery.length();
        let mon = startMonth;
        let year = startYear;
        const result = [];
        for (let i = 0; i <= len; ++i) {
            result.push(`${mon.toString().padStart(2, '0')}/${year}`);
            mon += 1;
            if (mon > 12) {
                year += 1;
                mon = 1;
            }
        }
        return result;
    }

    renderStatus(index) {
        this.status.innerText = this.dates[index];
    }
}

new App();
wrapper.markPageAsLoaded();
